/**************************************************
 * Nombre:       Dialogo_Subir_Foto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {CloudUpload} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Subir_Foto from "../Formularios/Formulario_Subir_Foto";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";

const Dialogo_Subir_Foto = ({datos, cerrar, realizado}) => {

    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data
        entidad.estado = 'Enviado'

        iniciarCarga('Subiendo Foto')
        let dox = await guardarDoc('movimientos', entidad)
        if (dox.res) {

            terminar({aviso: 'Foto enviadad exitosamente, espera a que se revise para ver los nuevos valores'})
        } else {
            terminar({aviso: 'Ups algo inesperado paso, intentalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{
                    fontSize: 32,
                    fontWeight: 800,
                    textAlign: 'center',
                    lineHeight: 1.1
                }}>{`Valor del deposito: ${formatoMoneda(datos.valor)}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Formulario_Subir_Foto props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<CloudUpload/>}
                >Subir Foto</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Subir_Foto